import convertFromKebabCase, { TARGET_CASE } from './convertFromKebabCase';


function createOptionMessageResolver(intl, messages, prefix, { formatValues = {}, targetCase = TARGET_CASE.camel } = {}) {
    return (value) => intl.formatMessage(
        messages.find(message => message.id === `${prefix}${convertFromKebabCase(value, targetCase)}`),
        formatValues,
    );
}

export {
    createOptionMessageResolver,
    TARGET_CASE,
};
